module.exports = __webpack_public_path__ + "img/qr_code.a30e07fd.svg";